import React, { useEffect, Fragment } from 'react';
import { get, pick } from 'lodash/fp';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import guestAddressLine from '../../../../helpers/guestAddressLine';
import { GuestType } from '../../../../interfaces/guest';
import formatFullName from '../../../../helpers/formatFullName';
import { VIEW_ADDRESS } from '../../../../constants/permissions/guest';
import { viewAccess } from '../../../../helpers/permission';
import AccessControl from '../../../../components/AccessControl';
import { fetchUserPermissions } from '../../../../redux/sagas/routines';
import { getIsFetched as getIsFetchedPermissions } from '../../../../redux/selectors/permission';

const AddressWrapper = styled.span`
  font-size: 12px;
  color: gray;
`;

const GuestDetails = ({ guest, ...props }) => {
  const dispatch = useDispatch();
  const isPermissionsFetched = useSelector(getIsFetchedPermissions);
  const address = guestAddressLine(guest, true, true);
  const fullName = formatFullName(
    pick(['firstname', 'middlename', 'lastname'], guest)
  );
  const isHomeless = get('homeless', guest) === 1;

  useEffect(
    () => {
      if (!isPermissionsFetched) dispatch(fetchUserPermissions());
    },
    [isPermissionsFetched]
  );
  return (
    <div {...props}>
      <h5>
        <span>#{get('id', guest)}</span>
        {' - '}
        {fullName}
        <AddressWrapper>
          &nbsp;-&nbsp;
          {isHomeless ? (
            'Homeless'
          ) : (
            <Fragment>
              {address.line1 && (
                <AccessControl allowOnlyFor={viewAccess(VIEW_ADDRESS)}>
                  <span>{address.line1}, </span>
                </AccessControl>
              )}
              {address.line2}
              {!address.line1 && !address.line2 && <span>No address</span>}
            </Fragment>
          )}
        </AddressWrapper>
      </h5>
    </div>
  );
};

GuestDetails.propTypes = {
  guest: GuestType.isRequired
};

export default GuestDetails;
